import React from "react";
import styled from "styled-components/macro";

export const Card = styled.section`
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
`;

export const CheckboxBox = styled.span`
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1px solid ${({ $checked }) => ($checked ? "#5B5FC7" : "#8A8886")};
    background: ${({ $checked }) => ($checked ? "#5B5FC7" : "#fff")};
    color: #fff;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const Checkbox = ({ checked }) => (
    <CheckboxBox $checked={checked}>{checked ? "✓" : ""}</CheckboxBox>
);

export const UnstyledButton = styled.button`
    border: none;
    background: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
`;

export const FieldBox = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 4px 10px;
    min-height: 32px;
    box-sizing: border-box;
    border-bottom: 2px solid
        ${({ $focused }) => ($focused ? "#5B5FC7" : "transparent")};
    font-size: 13px;
`;

export const PopoverPanel = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    min-width: 200px;
    max-height: 340px;
    overflow: auto;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
    z-index: 5;
    padding: 4px 0;
`;

export const PopoverItem = styled(UnstyledButton)`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 12px;
    font-size: 13px;
    text-align: left;
    &:hover {
        background: #f5f5f5;
    }
`;

export const PopoverSectionLabel = styled.div`
    padding: 8px 12px 4px;
    font-size: 11px;
    font-weight: 700;
    color: #616161;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-top: ${({ $separated }) =>
        $separated ? "1px solid #EDEBE9" : "none"};
`;

export const PopoverEmpty = styled.div`
    padding: 12px;
    font-size: 13px;
    color: #616161;
`;

export const CountPill = styled.span`
    font-size: 11px;
    font-weight: 400;
    background: #c5cbfa;
    padding: 1px 7px;
    border-radius: 9px;
`;

export const StatusSwatch = styled.span`
    width: 10px;
    height: ${({ $height }) => $height ?? 14}px;
    border-radius: 2px;
    background: ${({ $color }) => $color};
    flex-shrink: 0;
`;

export const Muted = styled.span`
    font-size: 12px;
    color: #616161;
    font-weight: 400;
`;

const AvatarCircle = styled.span`
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    border-radius: 50%;
    background: #edebe9 center / cover no-repeat;
    background-image: ${({ $src }) => ($src ? `url(${$src})` : "none")};
    font-size: ${({ $size }) => ($size > 26 ? 11 : 10)}px;
    font-weight: 600;
    color: #424242;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const InitialsAvatar = ({ initials, src, size = 30 }) => (
    <AvatarCircle $size={size} $src={src}>
        {src ? "" : initials}
    </AvatarCircle>
);

export const ResetButton = styled(UnstyledButton)`
    background: #fff;
    border: 1px solid #d1d1d1;
    border-radius: 4px;
    padding: 7px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #212121;
    &:hover {
        background: #f5f5f5;
    }
`;
